/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { CreateCaseMessageResponseJson } from './create-case-message-response-json';
import { CreateCaseMessageResult } from '../results/create-case-message-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { MessageDto } from '../models/message-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class CreateCaseMessageResponse extends ResponseWithErrorGeneric<CreateCaseMessageResponseJson, CreateCaseMessageResult> implements IResponseWithErrorGeneric<CreateCaseMessageResult> {
  public caseId: string = undefined;
  public caseMessageId: string = undefined;
  public caseMessage: MessageDto;

  //<custom-body>
  constructor(response: HttpResponse<CreateCaseMessageResponse>) {
    super(response, CreateCaseMessageResult.Error);
    if (this.result !== CreateCaseMessageResult.Success) {
      return;
    }
    
    this.caseId = this.body.caseId;
    this.caseMessageId = this.body.caseMessageId;
    this.caseMessage = new MessageDto(this.body.caseMessage);
  }
  //</custom-body>
}
